import React, {createContext} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import StaffStore from "./store/StaffStore";
import OrderStore from "./store/OrderStore";
import CatalogsStore from "./store/CatalogsStore";
import ProductsStore from "./store/ProductsStore";

const root = ReactDOM.createRoot(document.getElementById('root'));
export const Context = createContext(null)

root.render(
    <Context.Provider value={{
        staff: new StaffStore(),
        orders: new OrderStore(),
        catalogs: new CatalogsStore(),
        products: new ProductsStore()
    }}>
        <App />
    </Context.Provider>
);

